import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class FeedsService {
  API_BASE_PATH = environment.API_URL;

  constructor(private http: HttpClient) { }
 
  // Below API post business feeds
  addBusinessFeeds(formData: FormData ) {
    return this.http.post(`${this.API_BASE_PATH}business-feeds`, formData);
  }

  // Below API post product feeds
  addProductFeeds(formData: FormData ) {
    return this.http.post(`${this.API_BASE_PATH}product-feeds`, formData);
  }

  // Below API return business feeds
  fetchFeedsByBusinessUUID(UUID: string) {
    return this.http.get(`${this.API_BASE_PATH}business-feeds/${UUID}`);
  }

  // Below API return product feeds
  fetchFeedsByProduct(UUID: string, ID: string) {
    return this.http.get(`${this.API_BASE_PATH}product-feeds/${UUID}/${ID}`);
  }

  // Below API return product feeds
  fetchFeedsByProductUUID(UUID: string) {
    return this.http.get(`${this.API_BASE_PATH}product-feeds/${UUID}`);
  }

  // Below API return delete product feeds
  deleteFeedsByProduct(UUID: string, ID: string) {
    return this.http.delete(`${this.API_BASE_PATH}product-feeds/${UUID}/${ID}`);
  }

  // Below API return delete Business feeds
  deleteFeedsByBusiness(UUID: string, ID: string) {
    return this.http.delete(`${this.API_BASE_PATH}business-feeds/${UUID}/${ID}`);
  }
}
